import { QuillEditor, Quill } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'
window.Quill = Quill
export { QuillEditor, Quill }
